export default __webpack_public_path__ + "static/media/logo1.1d03a582.png";